module.exports = __webpack_public_path__ + "images/fpc-proof-bg-blog.webp";